export default __webpack_public_path__ + "static/media/lightning.917f1536.png";